/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DismissOktaServerSuggestionRequestBody,
  DismissOktaServerSuggestionRequestBody$Outbound,
  DismissOktaServerSuggestionRequestBody$outboundSchema,
} from "../components/dismissoktaserversuggestionrequestbody.js";

export type DismissOktaServerSuggestionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DismissOktaServerSuggestionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  dismissOktaServerSuggestionRequestBody:
    DismissOktaServerSuggestionRequestBody;
};

/** @internal */
export type DismissOktaServerSuggestionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DismissOktaServerSuggestionSecurity$outboundSchema: z.ZodMiniType<
  DismissOktaServerSuggestionSecurity$Outbound,
  DismissOktaServerSuggestionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function dismissOktaServerSuggestionSecurityToJSON(
  dismissOktaServerSuggestionSecurity: DismissOktaServerSuggestionSecurity,
): string {
  return JSON.stringify(
    DismissOktaServerSuggestionSecurity$outboundSchema.parse(
      dismissOktaServerSuggestionSecurity,
    ),
  );
}

/** @internal */
export type DismissOktaServerSuggestionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DismissOktaServerSuggestionRequestBody:
    DismissOktaServerSuggestionRequestBody$Outbound;
};

/** @internal */
export const DismissOktaServerSuggestionRequest$outboundSchema: z.ZodMiniType<
  DismissOktaServerSuggestionRequest$Outbound,
  DismissOktaServerSuggestionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    dismissOktaServerSuggestionRequestBody:
      DismissOktaServerSuggestionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      dismissOktaServerSuggestionRequestBody:
        "DismissOktaServerSuggestionRequestBody",
    });
  }),
);

export function dismissOktaServerSuggestionRequestToJSON(
  dismissOktaServerSuggestionRequest: DismissOktaServerSuggestionRequest,
): string {
  return JSON.stringify(
    DismissOktaServerSuggestionRequest$outboundSchema.parse(
      dismissOktaServerSuggestionRequest,
    ),
  );
}
